import { ArrowLeft, Calendar, Users, Plane, Hotel, Utensils, Waves, Anchor, Palmtree, Camera, Heart, Zap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const MAURITIUS_IMAGES = {
  day1: 'https://images.pexels.com/photos/30977598/pexels-photo-30977598.jpeg',
  day2: 'https://images.pexels.com/photos/34732391/pexels-photo-34732391.jpeg',
  day3: 'https://images.pexels.com/photos/13833135/pexels-photo-13833135.jpeg',
  day4: 'https://images.pexels.com/photos/34732418/pexels-photo-34732418.jpeg',
  day5: 'https://images.pexels.com/photos/34732381/pexels-photo-34732381.jpeg',
  day6: 'https://images.pexels.com/photos/65779/pexels-photo-65779.jpeg',
  day7: 'https://images.pexels.com/photos/10833435/pexels-photo-10833435.jpeg',
};

export default function Mauritius() {
  const navigate = useNavigate();
  const days = [
    { day: 1, title: 'Chegada & Clima Romântico', description: 'Bem-vindo ao paraíso tropical',
      highlights: [
        { icon: Plane, title: 'Transfer Privado', description: 'Após chegada ao aeroporto internacional, seu motorista privado o aguardará para um transfer confortável e exclusivo até o hotel.' },
        { icon: Hotel, title: 'Check-in & Descanso', description: 'Instale-se em sua suíte e aproveite o restante do dia para relaxar. Deixe-se envolver pela brisa do mar e a hospitalidade mauriciana.' },
        { icon: Heart, title: 'Noite Livre', description: 'Sugerimos um jantar romântico à luz de velas no restaurante do hotel, celebrando o início desta jornada inesquecível.' },
      ],
      quote: 'Bem-vindo ao paraíso onde o tempo desacelera e a beleza natural toma conta de cada momento.' },
    { day: 2, title: 'O Charme de Grand Baie', description: 'Descobrindo o norte vibrante',
      highlights: [
        { icon: Camera, title: 'Momentos Instagramáveis', description: 'Visite a famosa igreja de teto vermelho em Cap Malheureux, um dos pontos mais fotografados da ilha. Explore as águas calmas da Praia de Pereybère.' },
        { icon: Palmtree, title: 'Estilo de Vida & Compras', description: 'Grand Baie oferece uma mistura vibrante de boutiques de luxo, mercados locais e restaurantes premium. Aproveite a tarde para caminhar pela orla.' },
      ],
      quote: 'Grand Baie é o coração vibrante do norte, onde a cultura mauriciana encontra o luxo cosmopolita.' },
    { day: 3, title: 'Águas Cristalinas & Île aux Cerfs', description: 'Navegando em águas paradisíacas',
      highlights: [
        { icon: Anchor, title: 'Passeio de Catamarã', description: 'Navegue pelas águas azul-turquesa do Índico em um catamarã exclusivo, sentindo a brisa do mar e a hospitalidade mauriciana.' },
        { icon: Waves, title: 'Snorkeling Premium', description: 'Mergulhe em jardins de corais repletos de vida marinha colorida. Uma experiência imersiva em águas calmas e transparentes.' },
        { icon: Utensils, title: 'Almoço na Ilha', description: 'Desfrute de um almoço típico mauriciano servido a bordo ou na areia branca da Île aux Cerfs, cercado por um cenário de cartão-postal.' },
      ],
      quote: 'Île aux Cerfs é um paraíso intocado onde a natureza revela toda sua beleza.' },
    { day: 4, title: 'Sete Cores de Chamarel', description: 'Maravilha geológica única',
      highlights: [
        { icon: Zap, title: 'Sete Cores Naturais', description: 'Visite a famosa Terre de 7 Couleurs, uma formação geológica única onde o solo exibe tons vibrantes de vermelho, marrom, roxo e verde.' },
        { icon: Waves, title: 'Cachoeira de Chamarel', description: 'Contemple a majestosa queda d’água em meio à exuberante vegetação tropical, criando um cenário de tirar o fôlego.' },
        { icon: Utensils, title: 'Experiência Gastronômica', description: 'Jantar gourmet em um restaurante de luxo com vista para o oceano, degustando a culinária mauriciana de classe mundial.' },
      ],
      quote: 'Chamarel é onde a natureza pinta com cores que parecem saídas de um sonho.' },
    { day: 5, title: 'Golfinhos & Flic en Flac', description: 'Encontro com a natureza selvagem',
      highlights: [
        { icon: Palmtree, title: 'Avistamento de Golfinhos', description: 'Embarque em um passeio matinal para avistar golfinhos selvagens em seu habitat natural. Uma experiência mágica e inesquecível.' },
        { icon: Waves, title: 'Flic en Flac Beach', description: 'Relaxe em uma das praias mais famosas de Maurício, com areia branca e águas cristalinas. Perfeita para nadar e aproveitar o sol.' },
        { icon: Heart, title: 'Spa & Wellness', description: 'Desfrute de um tratamento relaxante no spa do resort, com massagens tradicionais mauricianas e terapias holísticas.' },
      ],
      quote: 'Flic en Flac é o refúgio perfeito para quem busca paz e beleza natural.' },
    { day: 6, title: 'Luxo & Resort', description: 'Comodidades premium e exclusividade',
      highlights: [
        { icon: Hotel, title: 'Dia de Piscina & Praia', description: 'Aproveite todas as comodidades do resort 5 estrelas, incluindo piscina privada, praia exclusiva e serviço de concierge impecável.' },
        { icon: Zap, title: 'Experiências Aquáticas', description: 'Atividades opcionais como jet ski, paddleboard, windsurfe ou mergulho com cilindro para os mais aventureiros.' },
        { icon: Utensils, title: 'Jantar Especial', description: 'Ceia gourmet no restaurante principal com menu degustação e seleção de vinhos premium de classe mundial.' },
      ],
      quote: 'O resort é seu santuário de luxo onde cada detalhe foi pensado para sua perfeição.' },
    { day: 7, title: 'Despedida do Paraíso', description: 'Encerramento da jornada inesquecível',
      highlights: [
        { icon: Palmtree, title: 'Manhã Livre', description: 'Últimos momentos na praia ou relaxando no resort, capturando as últimas memórias desta experiência extraordinária.' },
        { icon: Plane, title: 'Transfer para Aeroporto', description: 'Retorno ao aeroporto internacional com as memórias de uma semana inesquecível no paraíso.' },
        { icon: Heart, title: 'Embarque', description: 'Retorno com o coração cheio e a alma renovada pelas belezas de Maurício.' },
      ],
      quote: 'Leve consigo as memórias de um paraíso que tocou sua alma e transformou seu espírito.' },
  ];

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <div className="relative h-96 md:h-[500px] overflow-hidden">
        <img src={MAURITIUS_IMAGES.day1} alt="Mauritius" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white text-center mb-4">ROTEIRO ILHAS MAURÍCIO</h1>
          <p className="text-xl md:text-2xl text-white/90 text-center">O Paraíso no Índico</p>
        </div>
      </div>

      <div className="container py-6">
        <button onClick={() => navigate('/#destinations')} className="flex items-center gap-2 text-primary hover:text-accent font-semibold transition-colors">
          <ArrowLeft size={20} /> Voltar aos Destinos
        </button>
      </div>

      <div className="container py-12">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <p className="text-muted-foreground text-lg leading-relaxed mb-8">
            Uma jornada de 7 dias desenhada para equilibrar aventura, natureza e o mais alto nível de relaxamento tropical. Descubra praias de areia branca, recifes de coral vibrantes, formações geológicas únicas e a hospitalidade mauriciana de classe mundial.
          </p>
          <div className="grid grid-cols-3 gap-6 md:gap-8">
            <div className="flex flex-col items-center"><Calendar className="text-accent mb-2" size={32} /><p className="font-semibold text-primary">7 Dias</p></div>
            <div className="flex flex-col items-center"><Users className="text-accent mb-2" size={32} /><p className="font-semibold text-primary">A partir de 1 pessoa</p></div>
            <div className="flex flex-col items-center"><Plane className="text-accent mb-2" size={32} /><p className="font-semibold text-primary">Tudo Incluído</p></div>
          </div>
        </div>
      </div>

      <div className="container py-12 flex-1">
        <h2 className="text-4xl font-bold text-center text-primary mb-16">SEU CRONOGRAMA NO PARAÍSO</h2>
        <div className="space-y-16">
          {days.map((dayInfo, index) => (
            <div key={index} className="flex flex-col md:flex-row gap-8 items-stretch fade-in-up" style={{ animationDelay: `${index * 60}ms` }}>
              <div className="md:w-1/2">
                <img src={MAURITIUS_IMAGES[`day${dayInfo.day}`]} alt={dayInfo.title} className="w-full h-80 object-cover rounded-lg shadow-lg hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="md:w-1/2 flex flex-col justify-center">
                <div className="mb-4">
                  <span className="text-accent font-bold text-sm">DIA {dayInfo.day}</span>
                  <h3 className="text-3xl font-bold text-primary mt-2">{dayInfo.title}</h3>
                  <p className="text-muted-foreground mt-1">{dayInfo.description}</p>
                </div>
                <div className="space-y-4 mb-6">
                  {dayInfo.highlights.map((h, idx) => {
                    const Icon = h.icon;
                    return (
                      <div key={idx} className="flex gap-3">
                        <Icon className="text-accent flex-shrink-0" size={24} />
                        <div>
                          <p className="font-semibold text-primary">{h.title}</p>
                          <p className="text-muted-foreground text-sm">{h.description}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <blockquote className="border-l-4 border-accent pl-4 py-2 italic text-muted-foreground">“{dayInfo.quote}”</blockquote>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-slate-50 py-12 mt-16">
        <div className="container">
          <h2 className="text-3xl font-bold text-primary mb-8">O QUE ESTÁ INCLUÍDO</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="flex gap-4"><Hotel className="text-accent flex-shrink-0" size={32} /><div><h3 className="font-bold text-primary mb-2">Hospedagem Premium</h3><p className="text-muted-foreground">Resorts 5 estrelas em localizações paradisíacas</p></div></div>
            <div className="flex gap-4"><Plane className="text-accent flex-shrink-0" size={32} /><div><h3 className="font-bold text-primary mb-2">Transferências Privadas</h3><p className="text-muted-foreground">Todos os transportes em veículos premium</p></div></div>
            <div className="flex gap-4"><Anchor className="text-accent flex-shrink-0" size={32} /><div><h3 className="font-bold text-primary mb-2">Passeios & Atividades</h3><p className="text-muted-foreground">Todas as experiências conforme descrito no roteiro</p></div></div>
            <div className="flex gap-4"><Utensils className="text-accent flex-shrink-0" size={32} /><div><h3 className="font-bold text-primary mb-2">Refeições Gourmet</h3><p className="text-muted-foreground">Café da manhã, almoço e jantar em restaurantes premium</p></div></div>
          </div>
        </div>
      </div>

      <div className="container py-12">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-primary mb-4">Pronto para Viver Esta Experiência?</h2>
          <p className="text-muted-foreground mb-8">Entre em contato conosco e customize seu roteiro</p>
          <a href="https://wa.me/5548991904829?text=Olá! Gostaria de orçar o roteiro premium de Ilhas Maurício." target="_blank" rel="noopener noreferrer" className="btn-primary inline-block no-underline">
            Solicitar Orçamento via WhatsApp
          </a>
        </div>
      </div>

      <div className="bg-primary text-white py-8 mt-8">
        <div className="container text-center">
          <p className="font-semibold mb-2">PROPOSTA EXCLUSIVA | 2026</p>
          <p>@jmtravel.oficial | CNPJ 64.418.580/0001-14</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
